import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div<{ isFetching?: boolean }>`
  box-sizing: border-box;
  ${props => props.isFetching && `
    cursor: wait;
    > * {
      pointer-events: none;
    }
  `}

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      margin: 0;
      user-select: none;

      > div {
        input[type=checkbox] + span {
          margin: 2px 0;
        }

        &:first-child {
          padding: 10px 0;
          margin-top: 4px;
          border-top: 1px solid ${props => props.theme.palette.general.greyLight};
          background: transparent;
          font: ${font('default', 'bold', '16px/1')};

          strong {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          svg {
            width: 15px;
            height: 15px;
            margin-left: 5px;
            transform: rotate(-180deg);
            transform-origin: 50% 50%;
            transition: 300ms ease;

            &.isClosed {
              transform: rotate(0);
            }
          }
        }

        &:last-child {
          overflow: auto;
          margin: 0;
          padding: 0 0 15px;
          border: none;

          &.isClosed {
            display: none;
          }

          > div {
            label {
              display: flex;
              cursor: pointer;
              width: 100%;
              box-sizing: border-box;
              margin: 2px 0;
              padding: 2px 0;
            }

            span {
              display: flex !important;
              align-items: center;
              font: ${font('default', 'normal', '16px/1')};
              margin: 0 0 0 5px;
            }
          }
        }
      }
    }
  }
`

export const FilterButtonsWrapper = styled.div`
  > h4 {
    font-size: 14px;
    color: ${props => props.theme.palette.general.strong};
    font-weight: normal;
    margin-top: 12px;
  }

  button {
    transition: all ease-in-out 0.3s;
    box-shadow: none;
    outline: none;
    border: none;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    padding: 2px 6px;

    &.filter {
      background: ${props => props.theme.palette.general.strong};
      color: ${props => props.theme.palette.general.light};
      border-radius: 4px;
      font-size: 14px;
      margin-right: 8px;

      span {
        &:last-of-type {
          display: flex;
          align-items: center;
          margin-left: 10px;
        }
      }
    }

    &.remove {
      display: flex;
      background: transparent;
      color: ${props => props.theme.palette.general.greyDark};
      margin: 10px 0;

      > svg {
        margin-right: 10px;
      }
    }

    &:hover {
      opacity: 0.7;
    }
  }
`
